import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSelecionaParceiroFilhoModal } from '../../../hooks/SelecionaParceiroFilhoModalContext';
import backend from '../../../services/backend';

const SelecionaParceiroFilhoModal = () => {
  const { isOpen, closeModal, setParceiro } = useSelecionaParceiroFilhoModal();
  const [data, setData] = useState(null);
  const color = useColorModeValue('gray.800', 'white');

  useEffect(() => {
    const load = async () => {
      const response = await backend.get('/usuarios/selecao-vendedor');
      setData(response.data);
    };

    load();
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={closeModal} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color={color}>Selecionar parceiro</ModalHeader>
        <ModalCloseButton color={color} />
        <ModalBody>
          <Flex flexDir="column" maxH="600px" overflowY="auto">
            {data?.rows?.map(item => {
              return (
                <>
                  <Flex
                    borderWidth="1px"
                    p="3"
                    cursor="pointer"
                    onClick={() => {
                      setParceiro({
                        id: item.id,
                        nome: item.nome,
                      });
                      closeModal();
                    }}
                  >
                    <Text color={color}>{item?.nome}</Text>
                  </Flex>
                </>
              );
            })}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelecionaParceiroFilhoModal;
